import React, { useCallback, useEffect, useState } from 'react';
import EditUser from './editUser';
import { useDispatch, useSelector } from 'react-redux';
import { ROUTES } from 'constants/appRoutes';
import '../contacts.sass';
import {
    deleteSubscriber,
    getGroupList,
    getSubscribersList,
} from 'middleware/email';
import searchIcon from 'images/searchIcon.svg';
import NewList from './newList';
import closeIcon from 'images/close.svg';
import ContactTable from './contactTable';
import { Spinner } from 'react-bootstrap';
import EditList from './editList';
import ConfirmAlert from 'components/core/confirm-alert';
import { confirmAlert } from 'react-confirm-alert';
import Pagination from 'react-js-pagination';
import Select from 'react-select';
import _ from 'lodash';

export const extractFirstAndLastName = (fullName) =>
    fullName
        ? fullName.split(' ').length === 1
            ? { firstName: fullName, lastName: '' }
            : {
                firstName: fullName.split(' ').slice(0, -1).join(' '),
                lastName: fullName.split(' ').pop(),
            }
        : '';

const ContactList = () => {
    const dispatch = useDispatch();
    const email = useSelector((state) => state.email);
    const limit = 50;
    const [ open, setOpen ] = useState(false);
    const [ isDeleteLoading, setIsDeleteLoading ] = useState(false);
    // const [ isListing, setIsListing ] = useState(false);
    const [ selsectedGrp, setSelectedGrp ] = useState(null);
    const [ selectedRow, setSelectedRow ] = useState(null);
    const [ search, setSearch ] = useState('');
    const [ selectedList, setSelectedList ] = useState([]);
    const [ activePage, setActivePage ] = useState(0);
    const [ pageSize, setPageSize ] = useState( { value: 50, label: '50' } );

    const handleSearch = (_,val) => {
        if (val.length >= 3 || val.length === 0) {
            setSelectedGrp(null);
            setSearch(val);
            // const filteredArray = email.subscribersList?.data?.subscribers.filter(obj => {
            //     return Object.values(obj).some(value =>
            //         value.toString().toLowerCase().includes(query.toLowerCase())
            //     );
            // });
            // setFilteredItems(filteredArray);
            dispatch(getSubscribersList(null, val));
        }
    };
    const debounceFn = useCallback(_.debounce(handleSearch, 600), []);

    const handleClose = () => {
        setSearch('');
        dispatch(getSubscribersList(selsectedGrp?.id))
    };

    const handleOpenDialog = (modalName) => {
        setOpen(modalName);
    };

    const handleModal = () => {
        setSelectedRow(null);
        setOpen(null);
    };

    const handlePageChange = (pageNumber) => {
        dispatch(getSubscribersList(selsectedGrp?.id, search, pageNumber - 1, pageSize?.value));
        setActivePage(pageNumber);
    };

    const unselectedIds = email.subscribersList?.data?.subscribers
        .filter(item => !selectedList.includes(item.id))
        .map(item => item.id);

    const handleDeleteSubscriber = () => {

        const data = selectedList?.length > email.subscribersList?.metadata?.totalElements/2 && email.subscribersList?.metadata?.totalElements >= 20 ? {
            exceptSubscribers: unselectedIds,
            nItems: selectedList?.length
        } : { removeSubscribers: selectedList,
            nItems: selectedList?.length }

        const allPageData = !selsectedGrp?.id ? { all: true, nItems: email?.subscribersList?.metadata?.totalElements } : { all: true, listId: selsectedGrp?.id ,nItems: selsectedGrp?.subscribersCount }

        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <ConfirmAlert
                        key={ 'box' }
                        onClose={ onClose }
                        btnTitle={ selectedList?.length === email.subscribersList?.data?.subscribers?.length ? 'This Page' : null }
                        handleAllPageAction= { selectedList?.length === email.subscribersList?.data?.subscribers?.length ? ()=> dispatch(deleteSubscriber(allPageData, selsectedGrp?.id, setIsDeleteLoading,setSelectedList, setActivePage, setPageSize)) : null }
                        handleAction={ () =>
                            dispatch(deleteSubscriber(data,selsectedGrp?.id,setIsDeleteLoading,setSelectedList, setActivePage, setPageSize))
                        }
                        subHeading="By confirming this Subscriber & information will be deleted forever."
                    />
                );
            },
        });

    };

    const getSubscribers = async() => {

        await dispatch(getGroupList(null)).then(res=>{
            if(res?.length > 0){
                dispatch(getSubscribersList(selsectedGrp?.id))
            }
        })
    };

    useEffect(() => {
        dispatch({
            type: 'SET_ACTIVE_SIDEBAR',
            payload: ROUTES.CONTACTS,
        });

        getSubscribers();

    }, []);

    const groupClickHandler = (group) => {
        setSelectedGrp(group);
        dispatch(getSubscribersList(group.id));
        setSelectedList([]);
        setSearch('');
        setPageSize({ value: 50, label: '50' })
    };

    const handleEdit = (row) => {
        setSelectedRow(row);
        handleOpenDialog('EDIT_USER');
    };

    const handleGetAllSubscriber = () => {
        dispatch(getSubscribersList());
        setSelectedGrp(null);
        setSelectedList([]);
        setSearch('');
        setPageSize({ value: 50, label: '50' });

    };

    const options = [
        { value: 50, label: '50' },
        { value: 100, label: '100' },
        { value: 200, label: '200' },
        { value: 300, label: '300' },
        { value: 400, label: '400' },
        { value: 500, label: '500' }
    ];

    const handleChangePageSize = (selectedOption) => {
        setPageSize(selectedOption);
        dispatch(getSubscribersList(selsectedGrp?.id , search, 0, selectedOption?.value));
    };
    useEffect(() => {
        if(search?.length >= 3){
            dispatch(getSubscribersList(selsectedGrp?.id , search, 0, pageSize?.value));
        }
    }, [ ])

    return (
        <>
            <main style={ {  } } className="dashboard-data createNewBlog createNewPage pb-0">
                {email.listLoading ? (
                    <div
                        className="d-flex align-items-center justify-content-center"
                        style={ {
                            position: 'absolute',
                            background: 'transparent',
                            opacity: 0.6,
                            width: '96%',
                            height: '92vh',
                            margin: 'auto',
                        } }
                    >
                        <Spinner
                            variant="primary"
                            animation="border"
                            size={ 'md' }
                            role="status"
                        />
                    </div>
                ) : null}

                <section data-tut="reactour__iso" className="dashboard-body">
                    <div className="contacts-container">
                        <div className="contacts-header">
                            <div className="contact-title">Contacts</div>
                            <div className="contacts-header-input-wrapper justify-content-between">
                                <div className="d-flex align-items-center" style={ { gap: 10 } }>
                                    <span style={ { width: '20px' } }>
                                        <img width={ '20px' } height={ '20px' } src={ searchIcon } />
                                    </span>
                                    <input
                                        type='text'
                                        name="search"
                                        value={ search }
                                        onChange={ (e)=>{
                                            setSearch(e.target.value);
                                            debounceFn(e, e.target.value);
                                        } }
                                        className="header-input"
                                        placeholder="Search.."
                                    />
                                </div>
                                {search?.length ? (
                                    <img
                                        className="list-close-icon"
                                        onClick={ ()=>handleClose() }
                                        src={ closeIcon }
                                        width={ 18 }
                                        height={ 18 }
                                    />
                                ) : null}
                            </div>
                        </div>
                        <div className="custom-tabs">
                            <ul className="tab-list">
                                <li
                                    onClick={ handleGetAllSubscriber }
                                    className={ !selsectedGrp ? 'active-list-items' : 'list-items' }
                                >
                                    All Contacts
                                </li>
                                {email.groupList?.length
                                    ? email.groupList.map((group, i) => {
                                        return (
                                            <li
                                                className={
                                                    selsectedGrp?.id === group.id
                                                        ? 'active-list-items'
                                                        : 'list-items'
                                                }
                                                key={ `${ group.listName }-${ i }` }
                                                onClick={ () => groupClickHandler(group) }
                                            >
                                                {`${ group.listName } (${ group?.subscribersCount ?? '' })`}
                                            </li>
                                        );
                                    })
                                    : null}
                                <li
                                    className="add-new-list"
                                    onClick={ () => {
                                        handleOpenDialog('NEW_LIST');
                                    } }
                                >
                                    + New List
                                </li>
                                <li
                                    className="add-new-list"
                                    onClick={ () => {
                                        handleOpenDialog('EDIT_LIST');
                                    } }
                                >
                                    Edit List
                                </li>
                            </ul>
                            <button
                                className="add-user"
                                onClick={ () => handleOpenDialog('NEW_USER') }
                            >
                                + Add Users
                            </button>
                        </div>
                        <div className="d-flex justify-content-between mt-2">
                            <span className="d-flex">
                                <div>
                                    <div className="total-users">
                                        {search?.length >= 3 ? 'Search Results' : !selsectedGrp ? 'Total Users' : 'Total Users in List' }: {email?.subscribersList?.metadata?.totalElements ?? 0}
                                    </div>
                                    <div className="total-users mt-2">Users Selected: { selectedList?.length }</div>
                                </div>
                            </span>
                            <div className='d-flex flex-column' style={ { gap: '10px' } }>
                                {/* <div className="view-users">
                                    <span
                                        style={ { textDecorationLine: 'none' } }
                                        className="view-user-items"
                                    >
                                        View
                                    </span>
                                    <span className="view-user-items">10</span>
                                    <span className="view-user-items">50</span>
                                    <span className="view-user-items">All</span>
                                </div> */}
                                <button
                                    className="delete-btn w-100 ml-2 align-self-end"
                                    disabled={ !selectedList?.length ? true : false }
                                    style={ !selectedList?.length ? { cursor: 'not-allowed', background:'lightgrey', color: '#000' } : {} }
                                    onClick={ handleDeleteSubscriber }
                                >
                                    {isDeleteLoading ? <Spinner
                                        variant="light"
                                        animation="border"
                                        size={ 'sm' }
                                        role="status"
                                    />: 'Delete'}
                                </button>
                            </div>
                        </div>
                        <ContactTable
                            extractFirstAndLastName={ extractFirstAndLastName }
                            handleEdit={ handleEdit }
                            email={ email }
                            selectedList= { selectedList }
                            setSelectedList={ setSelectedList }
                            selsectedGrp={ selsectedGrp }
                            handleDelete={ handleDeleteSubscriber }
                        />
                        <div style={ { width: '100px' } } className='mt-2'>
                            <label>Page Size</label>
                            <Select
                                className={ 'reply-to-dropdown' }
                                value={ pageSize }
                                options={ options }
                                onChange={ handleChangePageSize }
                            />
                        </div>
                        {limit < email?.subscribersList?.metadata?.totalElements && (
                            <div className="blogs-pagination mb-0">
                                <Pagination
                                    activePage={ activePage == 0 ? 1 : activePage }
                                    itemsCountPerPage={ pageSize?.value ?? 50 }
                                    totalItemsCount={ email?.subscribersList?.metadata?.totalElements }
                                    pageRangeDisplayed={ 5 }
                                    onChange={ handlePageChange }
                                />
                            </div>
                        )}
                    </div>
                </section>
                <NewList handleModal={ handleModal } open={ !!(open === 'NEW_LIST') } />
                <EditUser
                    handleModal={ handleModal }
                    open={ !!(open === 'EDIT_USER' || open === 'NEW_USER') }
                    selectedRow={ selectedRow }
                    setSelectedRow={ setSelectedRow }
                    list={ email.groupList }
                    selectedGroup={ selsectedGrp }
                />
                <EditList emailGroupList= { email.groupList } handleModal={ handleModal } open={ !!(open === 'EDIT_LIST') } />
            </main>
        </>
    );
};

export default ContactList;
